//import Doctors from './screens/index.vue';
const Doctors = () => import('./screens/index.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const doctorsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.DOCTOR_VIEW,
    PERMISSIONS_KEYS.DOCTOR_INSERT,
    PERMISSIONS_KEYS.DOCTOR_EDIT,
    PERMISSIONS_KEYS.DOCTOR_DELETE,
  ])
) {
  doctorsRoutes.push({
    path: '/regras-da-prescricao/medicos',
    name: 'Cadastro / Consulta|Médico',
    component: Doctors,
    meta: {
      icon: 'fa-hospital',
      requiresAuth: true,
    },
  });
}

export { doctorsRoutes };
